<template>
  <avue-crud ref="crud" :data="table.data" :search.sync="searchForm" :option="table.option" :page.sync="table.page" :table-loading="table.loading"
    @on-load="onLoad" @search-change="onSearchChange"></avue-crud>
</template>

<script>
import { distributiontList } from '@/api/cube-agent/ag_produccharge_records'
export default {
  data() {
    return {
      searchForm: {},
      table: {
        data: [],
        option: {
          searchFilterNull: true,
          searchFilterDic: true,
          height: 'auto',
          addBtn: false,
          menu: false,
          searchMenuSpan: 6,
          index: true,
          border: true,
          column: [
            {
              label: '客户名称',
              prop: 'taxName',
            },
            {
              label: '所属机构',
              prop: 'department',
              dicUrl: '/api/cube-system/dept/deptDictionary?isShow=1',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              type: 'select',
              width: 95,
              search: true,
              overHidden: true, //超出是否隐藏
            },
            {
              label: '变动类型',
              prop: 'status',
              type: 'select',
              dicData: [
                {
                  label: '转出',
                  value: '1',
                },
              ],
            },
            {
              label: '调动原因',
              prop: 'adjustReason',
              type: 'select',
              dicData: [
                {
                  label: '新客户分配',
                  value: '1',
                },
                {
                  label: '部门调整',
                  value: '2',
                },
                {
                  label: '客户流失',
                  value: '3',
                },
              ],
            },
            {
              label: '备注',
              prop: 'remark',
            },
            {
              label: '操作人',
              prop: 'createName',
            },
            {
              label: '操作时间',
              prop: 'createTime',
            },
          ],
        },
        page: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        search: {},
      },
    }
  },
  methods: {
    async onSearchChange(f, d) {
      await this.onLoad()
        d()
    },
    async onLoad() {
      await this.$nextTick()
      this.search = this.searchForm
      const {
        data: {
          data: { records, total },
        },
      } = await distributiontList({
        ...this.filterClone(this.search),
        current: this.table.page.currentPage,
        size: this.table.page.pageSize,
      })
      this.table.data = records
      this.table.page.total = total
    },
  },
}
</script>

<style>
</style>
